<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
  export default {
    name: 'app',
    data() {
      return {
        shows: false
      }
    },
    methods: {
    },
    computed: {
    }
  }
</script>
<style lang="scss" scoped>
</style>
